import {session} from 'packages/session/session';
import {ConvertKilometersToMiles} from 'packages/units/ConvertKilometersToMiles';
import i18next from 'i18next';
import {isType1} from 'packages/helpers/IsType1';
import {isType234} from 'packages/helpers/ItType234';

/**
 * @param meters distance in meters
 * @param format printing format (e.g. "precise" - 13.71 km, 2.46 mi; "approx" - 14 km, 2 mi)
 */
export function PrintDistance(meters: number, format: 'approx' | 'precise'): string {
    const isImperialSystem = session.user.units_system === 'imperial';

    let distance = meters / 1000;

    if (isImperialSystem) {
        distance = ConvertKilometersToMiles(distance);
    }

    let result = Math.floor(distance + 0.5);
    switch (format) {
        case 'precise':
            result = Math.round(distance * 100) / 100;
            break;
    }

    return `${result} ${getDistanceMarker(result)}`;
}

export const getDistanceMarker = (distance: number, ignoreImperial?: boolean) => {
    const isImperialSystem = session.user.units_system === 'imperial' && !ignoreImperial;

    if (!isImperialSystem && i18next.language === 'ru') return 'км';
    if (!isImperialSystem && i18next.language !== 'ru') return 'km';

    switch (i18next.language) {
        case 'ru':
            if (isType1(distance)) return 'миля';
            if (isType234(distance)) return 'мили';
            return 'миль';
    }

    return 'mi';
};
